module.exports = __webpack_public_path__ + "static/media/tanishq_borkar.6eb16b79.png";